import { useState } from "react";
import { baseUrl } from "../../../shared/baseUrl";

function Reciters({ reciters, onreciterClick }) {
  const [page, setPage] = useState(1);
  const limit = 20;

  if (!Array.isArray(reciters)) return null;

  const displayedReciters = reciters.slice(0, page * limit);

  return (
    <>
      <div className="reciters-grid">
        {displayedReciters.map((reciter) => (
          <button
            key={reciter.id}
            className="reciter-card"
            onClick={() => onreciterClick(reciter)}
          >
            <img
              src={`${baseUrl}storage/${reciter.image}`}
              alt={reciter.name}
            />
            <h3>{reciter.name}</h3>
          </button>
        ))}
      </div>
      {displayedReciters.length < reciters.length && (
        <button className="load-more" onClick={() => setPage(page + 1)}>
          Load More
        </button>
      )}
    </>
  );
}

export default Reciters;
